import { render } from "./ExamList.vue?vue&type=template&id=4d89724e"
import script from "./ExamList.vue?vue&type=script&lang=ts"
export * from "./ExamList.vue?vue&type=script&lang=ts"

import "./ExamList.vue?vue&type=style&index=0&id=4d89724e&lang=scss"
script.render = render

export default script